import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const ScrollToTop: React.FC = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // Legacy support: if root URL contains ?scrollTo=contact, redirect to /contact
    try {
      const params = new URLSearchParams(search);
      const scrollTo = params.get("scrollTo");
      if (pathname === "/" && scrollTo === "contact") {
        navigate("/contact", { replace: true });
        return;
      }
    } catch {
      // ignore malformed search
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname, search, navigate]);

  return null;
};

export default ScrollToTop;
